/**
 * Owner statement picker: never apply owners[0].id when the URL already names an owner.
 */
function resolveOwnerPicker({ ownerFromUrl, ownerIdFromUrl, owners } = {}) {
  const list = Array.isArray(owners) ? owners : []
  const id = ownerIdFromUrl != null && Number.isFinite(Number(ownerIdFromUrl))
    ? Number(ownerIdFromUrl)
    : null
  const name = String(ownerFromUrl || '').trim()
  const byId = id != null ? list.find((o) => Number(o.owner_id) === id) : null
  const byName = name ? list.find((o) => String(o.owner_name || '') === name) : null
  const named = Boolean(name || id != null)
  const fallback = named ? null : (list[0] || null)
  const pick = byId || byName || fallback || {}
  return {
    ownerName: name || pick.owner_name || '',
    ownerId: id
      ?? (byName?.owner_id != null ? Number(byName.owner_id) : null)
      ?? (fallback?.owner_id != null ? Number(fallback.owner_id) : null),
  }
}

export { resolveOwnerPicker }
